<template>
    <div :class="$style.wrapper">
        <GameCard
            v-for="(game, index) in props.games"
            :key="game?.hru"
            :game="game"
            :targetLink="props.gameLinkTarget"
            :data-interface-target="`game-number-${index + 1}`"
            responsive
            type="rectangle"
            :lazy="!props.eagerThumbs || index >= props.eagerThumbs"
            :preload="props.preloadFirstCard && index === 0"
            withBadges
            withScaleOnHover
        />
        <MoreGamesCard
            :categoryName="props.categoryName"
            :games="props.games.slice(props.games.length - 3)"
            :to="props.link"
            type="rectangle"
        />
    </div>
</template>
<script lang="ts" setup>
import { RouteLocationRaw } from 'vue-router'

import GameCard from '@/components/GameCard/GameCard.vue'
import MoreGamesCard from '@/components/GamesShelf/MoreGamesCard.vue'
import { LinkTarget, ShortGameType } from '@/types'

const props = defineProps<{
    games: ShortGameType[] | undefined[]
    eagerThumbs?: number
    gameLinkTarget: LinkTarget | undefined
    preloadFirstCard?: boolean
    link?: RouteLocationRaw
    categoryName?: string
}>()
</script>
<style module>
.wrapper {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 12px 8px;
}

.wrapper > :first-child {
    grid-column: span 2;
}

.wrapper > :nth-child(-n + 11) {
    display: flex;
}

.wrapper > :nth-child(n + 11) {
    display: none;
}

@media (width >= 500px) {
    .wrapper {
        grid-template-columns: repeat(3, 1fr);
    }

    .wrapper > :first-child {
        grid-column: span 3;
    }

    .wrapper > :nth-child(-n + 13) {
        display: flex;
    }

    .wrapper > :nth-child(n + 13) {
        display: none;
    }
}

@media (width >= 640px) {
    .wrapper {
        grid-template-columns: repeat(4, 1fr);
    }

    .wrapper > :nth-child(-n + 2) {
        grid-column: span 2;
    }

    .wrapper > :nth-child(-n + 18) {
        display: flex;
    }

    .wrapper > :nth-child(n + 18) {
        display: none;
    }
}

@media (width >= 960px) {
    .wrapper {
        grid-template-columns: repeat(6, 1fr);
    }

    .wrapper > :nth-child(-n + 3) {
        grid-column: span 2;
    }

    .wrapper > :nth-child(-n + 21) {
        display: flex;
    }

    .wrapper > :nth-child(n + 21) {
        display: none;
    }
}

@media (width >= 1300px) {
    .wrapper {
        grid-template-columns: repeat(8, 1fr);
    }

    .wrapper > :nth-child(-n + 4) {
        grid-column: span 2;
    }

    .wrapper > :nth-child(-n + 20) {
        display: flex;
    }

    .wrapper > :nth-child(n + 20) {
        display: none;
    }
}

/* Ensure the last card (MoreGamesCard) is always visible */
.wrapper > :last-child {
    display: flex;
}
</style>
